import type { AsyncData } from "#app";
import type { IModelResponse } from "~/services/base/dto/base.dto";
import type { IModelGETPresetRequest, IModelGETPresetResponse } from "./dto/preset.dto";


export class PresetRepository {
  private api: any;
  private configService: any;
  private llmService: any;

  constructor(api: any, configService: any) {
    const runtimeConfig = useRuntimeConfig();
    this.api = api;
    this.configService = configService;
    this.llmService = runtimeConfig.public.apiLLMService
  }

  async getPreset(params: IModelGETPresetRequest): Promise<AsyncData<IModelResponse<IModelGETPresetResponse[]>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/preset`, this.configService, {
      params,
    });
    return dataResult;
  }

  async deletePreset(id: string | number): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/preset/${id}`, this.configService, {
      method: 'DELETE'
    });
    return dataResult;
  }

  async getPresetFile(fileName: string): Promise<AsyncData<any, any>> {
    const urlResult = await this.api(`${this.llmService}/v1/preset/file/${fileName}`, this.configService);
    const dataResult = await useFetch(urlResult.data.value.url, {
      responseType: 'blob'
    });
    return dataResult;
  }
}
